import { render, staticRenderFns } from "./navbars.vue?vue&type=template&id=70e8f1b0"
import script from "./navbars.vue?vue&type=script&lang=js"
export * from "./navbars.vue?vue&type=script&lang=js"
import style0 from "./navbars.vue?vue&type=style&index=0&id=70e8f1b0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports